import defaultAttributes from '../defaultAttributes';

const Code2 = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M18 16l4-4-4-4' }],
    ['path', { d: 'M6 8l-4 4 4 4' }],
    ['path', { d: 'M14.5 4l-5 16' }],
  ],
];

export default Code2;
